export default "__VITE_ASSET___RJgRZWe__"